export class User {
  userId: number;
  username: string;
  password: string;
  emailAddress: string;
  firstName: string;
  lastName: string;
  companyName: string;
  phoneNumber: string;
  preferredNotificationMethod: string;
  defaultPickUpLocationCode: string;
  primaryAddress: Address;
  cards: CreditCard[] = [];
  referralSource: string;

  customerNumber: string;

  constructor() {
    this.primaryAddress = new Address();
  }
}

export class Address {
  address1: string;
  address2: string;
  city: string;
  stateOrProvince: string;
  zipOrPostalCode: string;
  country: string = 'US';
}

export class CreditCard {
  cardId: number;
  cardholderName: string;
  billingAddress: Address;
  cardType: string;
  lastFour: string;
  expiryMonth: number | string;
  expiryYear: number | string;
}